




import React, { useState, useEffect } from 'react';
import { Card, Spin, Alert, Typography, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import './terms.css';
import { Box } from '@mui/material';

const { Title, Paragraph } = Typography;

const TermsConditionsPage = () => {
  const [content, setContent] = useState({
    title: '',
    content: '',
    lastUpdated: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/termsconditions');
      if (!response.ok) throw new Error('Failed to fetch content');
      const data = await response.json();
      setContent({
        title: data.terms?.title || 'Terms & Conditions',
        content: data.terms?.content || '',
        lastUpdated: data.terms?.lastUpdated || ''
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };



  if (loading) {
    return (
      <div className="about-ksm-page">
        <Header />
        <div className="loading-container">
          <Spin size="large" />
          <Paragraph>Loading Terms & Conditions...</Paragraph>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="about-ksm-page">
        <Header />
        <div style={{ padding: '20px' }}>
          <Alert
            message="Error Loading Terms & Conditions"
            description={error}
            type="error"
            showIcon
            action={
              <Button size="small" onClick={fetchContent}>
                Retry
              </Button>
            }
          />
        </div>
      </div>
    );
  }

  return (
    <div className="about-ksm-page">
      <Header />
      <div className="terms-conditions-page" >



        {/* Content Section */}
        <div className="terms-content-container">
          <Card className="terms-content-card">
            {/* Last Updated */}

            {/* Content Title */}
            <Title level={2} className="content-title">
              {content.title}
            </Title>

            {/* Main Content */}
            {/* <div
              className="terms-content-body rich-text-content"
              dangerouslySetInnerHTML={{
                __html: content.content ||
                  `<div class="no-content-message">
                  <p>No terms and conditions content available at the moment.</p>
                  <p>Please check back later or contact support for more information.</p>
                 </div>`
              }}
            /> */}

            <Box sx={{ p: 3 }}>
              <Box
                sx={{
                  // Base styles for all content
                  lineHeight: 1.5, // Increased line height for better readability
                  fontSize: '16px',
                  color: 'text.primary',

                  // Headings with proper spacing
                  '& h1, & h2, & h3, & h4, & h5, & h6': {
                    color: 'primary.main',
                    fontWeight: 'bold !important',
                    lineHeight: 1.4,
                    marginTop: '25px !important', // Space before heading
                    marginBottom: '10px !important', // Space after heading
                  },
                  '& h1': {
                    fontSize: '1.75rem',
                    marginTop: '0 !important', // No top margin for first heading
                  },
                  '& h2': {
                    fontSize: '1.5rem',
                    paddingBottom: '8px',
                    borderBottom: '2px solid',
                    borderColor: 'primary.main'
                  },
                  '& h3': { fontSize: '1.25rem' },
                  '& h4': { fontSize: '1.1rem' },

                  // Paragraphs with proper spacing
                  '& p': {
                    marginBottom: '12px !important', // Space between paragraphs
                    marginTop: '0 !important',
                    textAlign: 'justify',
                    lineHeight: 1.6, // Slightly tighter for paragraphs
                  },

                  // Empty paragraphs or line breaks
                  '& p:empty': {
                    marginBottom: '12px !important', // Smaller space for empty lines
                    height: '12px', // Visual height for empty lines
                  },

                  // Bold and italic text
                  '& strong, & b': {
                    fontWeight: 'bold !important',
                  },
                  '& em, & i': {
                    fontStyle: 'italic !important',
                  },

                  // Lists with proper spacing
                  '& ul, & ol': {
                    marginTop: '12px !important',
                    marginBottom: '20px !important',
                    paddingLeft: '32px',
                    lineHeight: 1.7,
                  },
                  '& li': {
                    marginBottom: '12px !important', // Space between list items
                    lineHeight: 1.6,
                  },
                  '& li:last-child': {
                    marginBottom: '0 !important',
                  },

                  // Links
                  '& a': {
                    color: 'primary.main',
                    textDecoration: 'underline',
                    '&:hover': {
                      color: 'primary.dark'
                    }
                  },

                  // Blockquotes
                  '& blockquote': {
                    borderLeft: '4px solid',
                    borderColor: 'primary.main',
                    backgroundColor: 'primary.50',
                    padding: '20px',
                    margin: '24px 0 !important',
                    fontStyle: 'italic',
                    borderRadius: '0 8px 8px 0',
                    lineHeight: 1.6,
                  },

                  // Horizontal rules for section breaks
                  '& hr': {
                    margin: '32px 0 !important',
                    border: 'none',
                    borderTop: '1px solid',
                    borderColor: 'divider',
                  },

                  // No content message
                  '& .no-content-message': {
                    textAlign: 'center',
                    padding: '60px 20px',
                    color: 'text.secondary',
                    lineHeight: 1.6,
                  },

                  // Specific spacing for your content structure
                  '& h2 + p': {
                    marginTop: '8px !important', // Less space after heading
                  },

                  '& p + ul, & p + ol': {
                    marginTop: '8px !important', // Less space before lists
                  },

                  '& ul + p, & ol + p': {
                    marginTop: '16px !important', // More space after lists
                  }
                }}
                dangerouslySetInnerHTML={{
                  __html: content.content ||
                    `<div class="no-content-message">
              <p>No terms and conditions content available at the moment.</p>
              <p>Please check back later or contact support for more information.</p>
            </div>`
                }}
              />
            </Box>

          </Card>
        </div>


      </div>
    </div>
  );
};

export default TermsConditionsPage;